/* jshint browser:true,newcap:false */
/* global kx:true */

(function(window, kx) {
	'use strict';

	kx.event.add('input', 'blur', function() {
		kx.style[(this.value !== '' ? 'add' : 'remove') + 'Class'](this, '--small');
	});
})(window, kx);
